<div class="form-container improved-asset-form">
  <div class="cardLayout improved-card shadow-lg">

    <!-- Header -->
    <ion-row class="align-center justify-between header-bar">

  <!-- Left: Title -->
  <ion-col size="8" class="ion-text-start">
    <div class="form-title">Asset Management for Employee</div>
  </ion-col>

  <!-- Right: Refresh & Close -->
  <ion-col size="4" class="ion-text-end">

    <!-- Refresh Icon -->
    <span class="ml-5 fs-20 material-icons btn-reset mr-2"
      style="cursor:pointer;"
      [class.clicked]="isClicked"
      (click)="resetGrid()"
      (animationend)="isClicked = false">
      refresh
    </span>

    <!-- Close Icon -->
    <img [mat-dialog-close] 
      src="././assets/icon/close_icon.png"
      class="close-icon cp ml-3"
      alt="close" />
  </ion-col>

</ion-row>

<!-- {{selectedAsset | json  }}
{{userListDataForAsset | json  }} -->
    <!-- Table Section -->
    <div class="table-section">
      <mat-sidenav-container class="sidenav-container rounded">
        <mat-sidenav-content>
          <ag-grid-angular
            class="ag-theme-quartz custom-ag-grid improved-grid"
            [rowData]="userListDataForAsset"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            (cellClicked)="onCelledClicked($event)"
            (cellValueChanged)="onCellValueChanged($event)"
            [pagination]="pagination"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }">
          </ag-grid-angular>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>

    <!-- Footer Buttons -->
    <div class="footer-buttons text-right mt-20">
      <button class="btn-outline fs-14 fs_12ForMobile" (click)="cancelData()">Cancel</button>
      <button
        type="button"
        class="btn-primary fs-14 fs_12ForMobile ml-10"
        [style.background-color]="buttonColorName"
        (click)="updateDataByEmployee()">
        Update
      </button>
    </div>

  </div>
</div>
